import { Component, Inject } from '@angular/core';

import { DialogRef, DIALOG_DATA, PromptConfig } from './common';

@Component({
  selector: 'qas-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: [ './prompt-dialog.component.scss' ]
})
export class PromptDialogComponent {
  promptValue: string;
  maxLength: number;
  config: PromptConfig;

  constructor(@Inject(DIALOG_DATA) { maxInputLength, promptConfig }: { maxInputLength: number, promptConfig: PromptConfig }, private dialogRef: DialogRef<PromptDialogComponent>) {
    this.maxLength = maxInputLength;
    this.config = promptConfig;
    this.promptValue = '';
  }

  accept() {
    this.dialogRef.close(this.promptValue);
  }
}
